import styled from 'styled-components';
import ds from 'designsystem';

const CustomLabel = styled.label`
    font-size: ${ds.fs('l')};
    color: ${ds.brand('text')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${ds.get('type.fontWeight.regular')};
    transition: all 0.2s;
    touch-action: manipulation;
    position: absolute;
    top: 1px;
    left: 0;
    opacity: 0.65;
`;

export default CustomLabel;



// WEBPACK FOOTER //
// ./src/blocks/Form/CustomLabel.jsx